<template>
  <div>
    <div class="prize_bg">
      <img class="prize_bg_image" v-if="prizeImage != null" :src="prizeImage" />
      <div class="prize_bg_center">
        <p class="prize_p_index" v-if="prizeIndex != null">
          第{{ prizeIndex }}期奖品
        </p>
        <p class="prize_p_name" v-if="prizeName != null">
          {{ prizeName }}
        </p>
        <p class="prize_p_price" v-if="prizePrice != null">
          价值 ¥ {{ prizePrice }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
@Options({
  props: {
    prizeIndex: String,
    prizeName: String,
    prizePrice: String,
    prizeImage: String
  }
})
export default class Prize extends Vue {
  // msg!: string;
}
</script>

<style scoped lang="less">
.prize_bg {
  height: 240px;
  // width: ~"(100% - 40px)";
  margin-left: 20px;
  margin-right: 20px;
  left: 0px;
  right: 0px;
  text-align: center;
  overflow: hidden;
  .prize_bg_image {
    width: 100%;
    float: left;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 240px;
    border-radius: 10px;
    object-fit: cover;
  }
  .prize_bg_center {
    left: 0;
    right: 0;
    margin-left: 20px;
    margin-right: 20px;
    position: absolute;
    .prize_p_index {
      width: 120px;
      height: 28px;
      margin: 0 auto;
      margin-top: 23px;
      padding: 6px 24px 0px 24px;
      top: 23px;
      border: 1px solid #ffffff;
      border-radius: 30px;
      font-size: 14px;
      color: #ffffff;
    }
    .prize_p_name {
      width: 100%;
      margin: 0 auto;
      margin-top: 10px;
      top: 23px;
      font-size: 14px;
      color: #ffffff;
    }
    .prize_p_price {
      width: 100%;
      margin: 0 auto;
      margin-top: 10px;
      top: 23px;
      font-size: 12px;
      color: #ffffff;
    }
  }
}
</style>
